import {Drawer, DrawerProps, ScrollArea} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {MeterReading} from "../types.ts";

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: MeterReading,
        handleSubmit: (values: MeterReading) => void
    }) => {

    const title = record?.id ? `Edit Meter Reading` : `Add Meter Reading`;

    const handleFormSubmit = async (values: MeterReading) => {
        await handleSubmit(values);
        onClose();
    };

    return (
        <Drawer
            transitionProps={{
                transition: "slide-left",
                duration: 750,
                timingFunction: "ease"
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title={title}
            padding="xl"
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </Drawer>
    )
};
